import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {Component, Inject} from '@angular/core';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MarkantElementsModule} from '@markant/elements-angular';
import {MatInput} from '@angular/material/input';

export interface DialogData {
  title: string;
  message: string;
  inputLabel?: string;
  input?: string;
}

export interface DialogResult {
  confirmed: boolean;
  input?: string;
}

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss'],
  standalone: true,
  imports: [MatDialogContent, ReactiveFormsModule, MatFormField, MatLabel, MatDialogActions, MarkantElementsModule, MatInput, MatDialogTitle],
})
export class InputDialogComponent {
  form: UntypedFormGroup;
  title: string;
  message: string;
  inputLabel: string | undefined;
  dialogResult: DialogResult;

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly dialogRef: MatDialogRef<InputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: DialogData,
  ) {
    this.title = data.title;
    this.message = data.message;
    this.inputLabel = data.inputLabel;

    this.form = fb.group({
      inputField: [data.input, []],
    });

    this.subscripeOnOtherClosingEvents();
  }

  submit() {
    this.dialogResult = {
      confirmed: true,
      input: this.form.value.inputField,
    };
    this.dialogRef.close(this.dialogResult);
  }

  cancel() {
    this.dialogResult = {
      confirmed: false,
    };
    this.dialogRef.close(this.dialogResult);
  }

  private subscripeOnOtherClosingEvents() {
    // The dialog can also be closed by escape key or by clicking on background. Then the cancel-method would not be called automatically.
    this.dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.cancel();
      }
    });
    this.dialogRef.backdropClick().subscribe(() => this.cancel());
  }
}
